<template>
  <div
    :class="{
      'max-w-md p-6': !isBanner,
      'py-3 px-4 m:px-8 m:pt-5 fixed bottom-0 left-0 right-0 bg-pale-mint-grey border-solid border-t border-r-0 border-l-0 border-b-0 border-light-grey z-50 flex flex-col m:flex-row m:gap-4 shadow-[0_0_5px_rgba(149,157,165,0.5)]':
        isBanner
    }"
  >
    <div class="grow" :class="{ 'l:w-1/2': isBanner }">
      <h2 class="font-bold text-midnight" :class="{ 'mb-2 text-h3': !isBanner, 'mb-1 text-h4 m:text-h3': isBanner }">
        {{ $t("headline") }}
      </h2>
      <p class="text-dark-grey" :class="{ 'text-xs m:text-base mb-2': isBanner }">
        {{ $t("copy") }}
        <a :href="$options.privacyPath" class="text-dark-grey underline">
          <span>{{ $t("privacy") }}</span> </a
        >.
      </p>
    </div>
    <div
      class="flex flex-col items-center justify-center min-w-64"
      :class="{ 'gap-4': !isBanner, 'gap-2 l:flex-row-reverse grow': isBanner }"
    >
      <button
        class="w-full js-pw-link whitespace-nowrap"
        :class="{ 'l:w-fit': isBanner }"
        @click="$emit('consent-all')"
        data-event-category="popup-20200728-cookie_disclaimer_all"
        data-event-depth="1"
        data-event-action="click"
        data-testid="cookie-disclaimer-all-cookies"
      >
        <span class="button button--full button--midnight">{{ $t("allowAllCookies") }}</span>
      </button>
      <div class="flex w-full justify-around" :class="{ 'm:gap-2 l:w-1/2 l:mr-4': isBanner }">
        <button
          class="text-mid-grey cursor-pointer font-medium hover:text-midnight js-pw-link"
          data-modal-open-step="cookie-banner:settings"
          data-event-category="popup-20200728-cookie_disclaimer_settings"
          data-event-depth="1"
          data-event-action="click"
          @click="$emit('open-settings')"
          data-testid="cookie-disclaimer-settings"
        >
          <span>{{ $t("cookieSettings") }}</span>
        </button>
        <button
          class="text-mid-grey cursor-pointer font-medium hover:text-midnight js-pw-link"
          data-event-category="popup-20200728-cookie_disclaimer_reject_all"
          data-event-depth="1"
          data-event-action="click"
          @click="$emit('reject-all')"
          data-testid="cookie-disclaimer-reject-all"
        >
          <span>{{ $t("rejectAllCookies") }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import globals from "@/utils/globals"

export default {
  name: "CookieDisclaimer",
  privacyPath: globals.routes.privacyCookiebot,
  props: {
    isBanner: {
      type: Boolean,
      default: false
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "We use Cookies 🍪",
        copy: 'By clicking "Accept All Cookies", you agree to the storing of cookies on your device to enhance site navigation, analyze site usage, and assist in our marketing efforts. If not, only necessary cookies will be used.',
        privacy: "Our Cookie Policy",
        allowAllCookies: "Allow all cookies",
        cookieSettings: "Cookie settings",
        rejectAllCookies: "Reject all"
      },
      de: {
        headline: "Wir verwenden Cookies 🍪",
        copy: "Indem du auf „Alle Cookies akzeptieren“ klickst, stimmst du der Speicherung von Cookies auf deinem Gerät zu. Cookies verbessern die Navigation auf der Website, analysieren die Nutzung der Website und helfen uns dabei, dir besseres Marketing zu bieten. Wenn du nicht alle Cookies akzeptierst, werden nur notwendige Cookies verwendet. Unsere",
        privacy: "Cookie-Richtlinie",
        allowAllCookies: "Alle Cookies akzeptieren",
        cookieSettings: "Cookie-Einstellungen",
        rejectAllCookies: "Alle ablehnen"
      },
      es: {
        headline: "Usamos Cookies 🍪",
        copy: 'Al hacer clic en "Aceptar todas las cookies", acepta el almacenamiento de cookies en su dispositivo para mejorar la navegación del sitio, analizar el uso del sitio y ayudar en nuestros esfuerzos de marketing. En caso contrario, solo se utilizarán las cookies necesarias. Nuestra',
        privacy: "Política de Cookies",
        allowAllCookies: "Aceptar Cookies",
        cookieSettings: "Configurar cookies",
        rejectAllCookies: "Rechazar todo"
      }
    }
  }
}
</script>
